import { render, staticRenderFns } from "./ConfirmAdditional.vue?vue&type=template&id=2ea35f6e&scoped=true"
import script from "./ConfirmAdditional.vue?vue&type=script&lang=js"
export * from "./ConfirmAdditional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea35f6e",
  null
  
)

export default component.exports